module.exports = "/_next/static/images/operator-logos-a233b9194658c7ff4fa4e32e37218daf.svg";